//updates worker information.
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BackButton from '../components/BackButton'
import { useSelector, useDispatch } from 'react-redux'
import { updateWorker, reset, terminateWorker } from '../features/workers/workerSlice';
import { toast } from 'react-toastify'
import { FaEdit } from 'react-icons/fa';


const UpdateWorkerInfo = () => {
  //props passed from previous route on click. 
  const location = useLocation();
  const dispatch = useDispatch();
  const props = location.state;
  

  // const user = useSelector()


  //redux states
  const {message, isSuccess} = useSelector(state => state.workers)
    //whenever the message changes, show a toast message
    useEffect(() => {
  

      if(message) {
        if(isSuccess === false){
          toast.error(message);
        } else {
          toast.success(message);
        }
        dispatch(reset())
      }
        
    }, [message, isSuccess, dispatch]);


  const [editMode, setEditMode] = useState({
    rate: false,
    role: false,
    name: false,
    lastName: false,
    // phone is not editable
  });

  const [formData, setFormData] = useState({
    workerID: props.currentWorkerData.id,
    newRole: props.currentWorkerData.role || '',
    newRate: props.currentWorkerData.rate || '',
    newName: props.currentWorkerData.name || '',
    newLastName: props.currentWorkerData.lastName || '',
  });



  const handleInputChange = (event) => {
    const { name, value } = event.target;

    let formattedValue = value;
    if (name === 'newPhone') {
      // Remove all non-digit characters
      formattedValue = formattedValue.replace(/\D/g, '');
  
      // Add dashes in the pattern ###-###-####
      if (formattedValue.length > 3) {
        formattedValue = formattedValue.slice(0, 3) + '-' + formattedValue.slice(3);
      }
      if (formattedValue.length > 7) {
        formattedValue = formattedValue.slice(0, 7) + '-' + formattedValue.slice(7, 11);
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue
    }));
  };

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return phoneNumber;
  };


  const handleSubmit = (e) => {
    
    e.preventDefault(); 
    //dispath the updateWorker function with formData as parameter. 
     dispatch( updateWorker( formData) )

  };

  //Pass the worker id and a user token to the terminateWorker function.

  // Modal state
  const [showModal, setShowModal] = useState(false);

  const handleRemoveWorker = (e) => {
    e.preventDefault();
    setShowModal(true);
  };

  const handleConfirmDelete = () => {
    setShowModal(false);
    dispatch(terminateWorker(props.currentWorkerData.id));
  };

  const handleCancelDelete = () => {
    setShowModal(false);
  };

  const handleEditClick = (field) => {
    setEditMode((prev) => ({ ...prev, [field]: true }));
  };

  const handleInputBlur = (field) => {
    setEditMode((prev) => ({ ...prev, [field]: false }));
  };

  const handleInputKeyDown = (e, field) => {
    if (e.key === 'Enter') {
      setEditMode((prev) => ({ ...prev, [field]: false }));
    }
  };

  return (
    <>
      <div className="min-h-screen bg-bg flex items-center justify-center py-6 px-2 sm:px-0">
        <div className="w-full max-w-lg bg-surface rounded-2xl border border-border shadow-sm p-4 sm:p-8 flex flex-col items-center">
          <form onSubmit={handleSubmit} className="w-full flex flex-col gap-6">
            <div className="flex flex-col items-center w-full p-4 rounded-xl bg-surface-2 mb-2 sm:mb-4">
              <img
                src={props.currentWorkerData.profilePicture}
                alt="Worker"
                className="w-24 h-24 rounded-full object-cover border-4 border-border shadow mb-2"
              />
              <div className="flex flex-col sm:flex-row items-center w-full justify-center gap-1 sm:gap-3 mt-2">
                <span className="capitalize font-semibold text-ink">Phone:</span>
                <span className="text-ink-2 tracking-wide">{formatPhoneNumber(props.currentWorkerData.phone)}</span>
              </div>
              {/* Editable fields */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full mt-4">
                {/* Name */}
                <div className="flex items-center justify-between bg-surface rounded-lg px-2 py-1 border border-border">
                  <span className="font-semibold text-ink">Name:</span>
                  {editMode.name ? (
                    <input
                      name="newName"
                      type="text"
                      value={formData.newName}
                      onChange={handleInputChange}
                      onBlur={() => handleInputBlur('name')}
                      onKeyDown={(e) => handleInputKeyDown(e, 'name')}
                      className="ml-2 p-1 border border-border rounded-md w-28 sm:w-32 focus:outline-none focus:ring-2 focus:ring-brand/40"
                      autoFocus
                    />
                  ) : (
                    <span className="flex items-center text-ink-2 ml-2">
                      {formData.newName}
                      <button type="button" className="ml-2 text-ink-3 hover:text-ink" onClick={() => handleEditClick('name')}>
                        <FaEdit />
                      </button>
                    </span>
                  )}
                </div>
                {/* Last Name */}
                <div className="flex items-center justify-between bg-surface rounded-lg px-2 py-1 border border-border">
                  <span className="capitalize font-semibold text-ink">Last Name:</span>
                  {editMode.lastName ? (
                    <input
                      name="newLastName"
                      type="text"
                      value={formData.newLastName}
                      onChange={handleInputChange}
                      onBlur={() => handleInputBlur('lastName')}
                      onKeyDown={(e) => handleInputKeyDown(e, 'lastName')}
                      className="ml-2 p-1 border border-border rounded-md w-28 sm:w-32 focus:outline-none focus:ring-2 focus:ring-brand/40"
                      autoFocus
                    />
                  ) : (
                    <span className="flex items-center text-ink-2 ml-2">
                      {formData.newLastName}
                      <button type="button" className="ml-2 text-ink-3 hover:text-ink" onClick={() => handleEditClick('lastName')}>
                        <FaEdit />
                      </button>
                    </span>
                  )}
                </div>
                {/* Rate */}
                <div className="flex items-center justify-between bg-surface rounded-lg px-2 py-1 border border-border">
                  <span className="capitalize font-semibold text-ink">Rate:</span>
                  {editMode.rate ? (
                    <input
                      name="newRate"
                      type="number"
                      step="0.01"
                      value={formData.newRate}
                      onChange={handleInputChange}
                      onBlur={() => handleInputBlur('rate')}
                      onKeyDown={(e) => handleInputKeyDown(e, 'rate')}
                      className="ml-2 p-1 border border-border rounded-md w-20 sm:w-24 focus:outline-none focus:ring-2 focus:ring-brand/40"
                      min={7.25}
                      autoFocus
                    />
                  ) : (
                    <span className="flex items-center text-ink-2 ml-2">
                      {formData.newRate}
                      <button type="button" className="ml-2 text-ink-3 hover:text-ink" onClick={() => handleEditClick('rate')}>
                        <FaEdit />
                      </button>
                    </span>
                  )}
                </div>
                {/* Role */}
                <div className="flex items-center justify-between bg-surface rounded-lg px-2 py-1 border border-border">
                  <span className="capitalize font-semibold text-ink">Role:</span>
                  {editMode.role ? (
                    <input
                      name="newRole"
                      type="text"
                      value={formData.newRole}
                      onChange={handleInputChange}
                      onBlur={() => handleInputBlur('role')}
                      onKeyDown={(e) => handleInputKeyDown(e, 'role')}
                      className="ml-2 p-1 border border-border rounded-md w-20 sm:w-24 focus:outline-none focus:ring-2 focus:ring-brand/40"
                      autoFocus
                    />
                  ) : (
                    <span className="flex items-center text-ink-2 ml-2">
                      {formData.newRole}
                      <button type="button" className="ml-2 text-ink-3 hover:text-ink" onClick={() => handleEditClick('role')}>
                        <FaEdit />
                      </button>
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 justify-evenly items-center w-full mt-2 sm:mt-4">
              <BackButton url={"/workers"} />
              <button
                type="button"
                className="w-full sm:w-auto text-critical border border-critical px-4 py-2 rounded-lg hover:bg-critical/10 transition text-label font-medium"
                onClick={handleRemoveWorker}
              >
                Delete Worker
              </button>
              <button
                type="submit"
                className="w-full sm:w-auto bg-ink text-white rounded-lg text-label font-medium px-4 py-2 hover:bg-ink-2 transition"
              >
                Update Worker Info
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Delete confirmation modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-surface border border-border rounded-xl shadow-lg p-6 w-11/12 max-w-sm flex flex-col items-center">
            <h2 className="text-section font-semibold text-critical mb-2">Confirm Delete</h2>
            <p className="mb-4 text-center text-body text-ink-2">Are you sure you want to delete <span className="font-semibold text-ink">{formData.newName} {formData.newLastName}</span>?</p>
            <div className="flex gap-4 w-full justify-center">
              <button
                onClick={handleCancelDelete}
                className="px-4 py-2 rounded-lg border border-border bg-surface-2 text-ink-2 text-label font-medium hover:bg-surface transition"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmDelete}
                className="px-4 py-2 rounded-lg bg-critical text-white text-label font-medium hover:bg-red-700 transition"
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UpdateWorkerInfo


